<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('academyEvent') }}</v-toolbar-title>
      <v-checkbox
        v-model="type"
        class="mt-6  mx-3"
        :label="$t('inerview')"
        value="interview"
      />
      <v-checkbox
        v-show="$store.state.absentSms == 'active'"
        v-model="absentSms"
        class="mt-6  mx-3"
        :label="$t('absentSms')"
        value="active"
      />
      <v-spacer />
      <v-checkbox
        v-model="status"
        class="mt-6 mx-4"
        :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
        value="active"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'academyEventList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('academyEventList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="name"
              :label="$t('name')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <autocomplete
              v-model="category"
              title="academyCategory"
              type="academyCategory"
              :value="category"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="number"
              :label="$t('number')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
              @blur="getEventNumber"
            />
          </v-col>
          <v-col
            v-if="!type"
            cols="12"
            md="3"
          >
            <money
              v-model="amount"
              :label="$t('eventAmount')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              class="mb-3 dense"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <autocomplete
              v-model="place"
              title="academyPlace"
              type="academyPlace"
              :value="place"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <autocomplete
              v-model="teacher"
              title="teacher"
              type="person"
              :new-btn="true"
              :data="JSON.stringify({type: 'teacher'})"
              :value="teacher"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <money
              v-model="teacherCost"
              :label="$t('teacherCost') + '(' + $t('perSession') + ')'"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              class="mb-3 dense"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="sessionCount"
              :label="(type === 'interview' ? $t('sessionCount') : $t('sessionCount'))"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
              type="number"
              :rules="numberRules"
              @focus="focusEvent"
            />
          </v-col>
          <v-col
            v-if="type"
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="sessionCountDay"
              :label="$t('dayCountSession')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
              type="number"
              :rules="numberRules"
              @focus="focusEvent"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <template>
              <v-text-field
                id="sDate"
                v-model="startDate"
                :label="$t('startDate')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="startDate"
                element="sDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              ref="duartionRef"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="duration"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="duration"
                  :label="$t('duration')"
                  append-icon="mdi-clock-time-four-outline"
                  readonly
                  dense
                  outlined
                  height="20"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="menu2"
                v-model="duration"
                class="mt-0"
                :allowed-minutes="allowedStep"
                format="24hr"
                full-width
                scrollable
                @click:minute="$refs.duartionRef.save(duration)"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              ref="startTimeRef"
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="startTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startTime"
                  :label="$t('startTime')"
                  append-icon="mdi-clock-time-four-outline"
                  readonly
                  dense
                  outlined
                  height="20"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="menu1"
                v-model="startTime"
                class="mt-0"
                :allowed-minutes="allowedStep"
                format="24hr"
                full-width
                scrollable
                @click:minute="$refs.startTimeRef.save(startTime)"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <tag
              v-model="tag"
              :solo="false"
              :input="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <v-btn
              :color="(!eventColor ? 'primary' : eventColor)"
              class="mr-0 mt-1"
              small
              block
              @click="colorPickerdialog = true"
            >
              {{ $t('selectColor') }}
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <aicomplete
              v-model="branch"
              title="branch"
              type="branch"
              :val="branch"
              :set-init="true"
              :new-btn="true"
            />
          </v-col>
          <v-col cols="12">
            <div> {{ $t('daysHolding') }}</div>
            <v-chip-group
              v-model="days"
              column
              multiple
            >
              <v-chip
                v-for="(day, i) in daysList"
                :key="i"
                filter
                outlined
                :value="day"
              >
                {{ $t(day) }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
        <v-row class="mx-0">
          <calender
            :events-prop="events"
            :place-prop="place"
            :start-time="startTime"
          />
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!sessionCreated"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="review"
            >
              {{ $t('createAndReviewSessions') }}
            </v-btn>
            <v-btn
              v-if="!id"
              color="green"
              class="mr-2"
              style="margin-right: 8px !important;"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="green"
              class="mr-2"
              style="margin-right: 8px !important;"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo( 'academyEventList' )"
            >
              {{ $t('academyEventList') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="colorPickerdialog"
      width="300"
    >
      <v-card
        class="pl-4"
      >
        <v-col>
          <v-color-picker
            v-model="eventColor"
            dot-size="25"
            hide-canvas
            hide-inputs
            hide-mode-switch
            hide-sliders
            mode="hexa"
            show-swatches
            swatches-max-height="132"
          />
        </v-col>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="pink"
            text
            @click="colorPickerdialog = !colorPickerdialog"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Calender from './partial/calender'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import aicomplete from '../../components/general/AIcomplete/index'
  export default {
    name: 'AcademyCategory',
    components: {
      aicomplete,
      Snakbar,
      Calender,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      branch: null,
      tag: null,
      render: false,
      isLoading: false,
      absentSms: null,
      number: 1,
      colorPickerdialog: false,
      sessionCreated: null,
      status: 'active',
      menu2: null,
      menu1: null,
      duration: '01:00',
      startTime: '12:00',
      eventColor: 'primary',
      amount: null,
      sessionCountDay: null,
      sessionCount: null,
      teacherCost: null,
      teacher: null,
      type: null,
      start: null,
      end: null,
      events: null,
      category: null,
      place: null,
      days: null,
      daysList: null,
      checkNumber: null,
      startDate: null,
      name: null,
      valid: null,
      numberRules: [
        v => !!v || 'This field is required',
        v => (v && v >= 0) || 'The number must be bigger than zero',
      ],
      timer: 0,
      message: null,
      id: null,
      loading: false,
    }),
    computed: {
    },
    watch: {
      snakbar () {
      },
      category (val, oldVal) {
        if (val) {
          if (!this.name) {
            this.name = val.name + '-' + this.number
          }
        }
        if (!this.tag && val.tags) {
          this.tag = val.tags
        }
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.getEventNumber()
      }
      this.daysList = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
    },
    mounted () {
    },
    methods: {
      allowedStep: m => m % 5 === 0,
      getDayNumber (day) {
        var number
        switch (day) {
          case 'Saturday':
            number = 1
            break
          case 'Sunday':
            number = 2
            break
          case 'Monday':
            number = 3
            break
          case 'Tuesday':
            number = 4
            break
          case 'Wednesday':
            number = 5
            break
          case 'Thursday':
            number = 6
            break
          case 'Friday':
            number = 7
            break
        }
        return number
      },
      review () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            checkEvent: 'active',
            type: app.type,
            name: app.name,
            days: app.days,
            startDate: app.startDate,
            startTime: app.startTime,
            duration: app.duration,
            sessionCount: app.sessionCount,
            sessionCountDay: app.sessionCountDay,
            teacher: app.teacher,
            teacherCost: app.teacherCost,
            color: (app.eventColor !== 'primary' ? app.eventColor : app.colors[app.rnd(0, app.colors.length - 1)]),
            place: app.place,
          },
        })
          .then(res => {
            res = res.data
            app.events = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'academyEvents', app.$data)
          .then(res => {
            app.goTo('academyEventList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      getEventNumber () {
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              id: app.id,
              number: app.number,
              select: 'academyGetNumberEvent',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
              }
              app.checkNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        this.loading = false
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academyEvents/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.type = res.type
              app.branch = res.branch
              app.amount = res.amount
              app.absentSms = res.absent_sms
              app.status = res.status
              app.number = res.number
              app.teacher = res.teacher
              app.teacherCost = res.teacher_cost
              app.place = res.place
              app.eventColor = res.color
              app.startDate = res.start_date
              app.startTime = res.start_time
              app.duration = res.duration
              app.duration = res.duration
              app.sessionCount = res.session_count
              app.category = res.category
              app.days = res.arrayDays
              app.tag = res.tags
              app.sessionCreated = res.sessionCreated
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'academyEvents/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.goTo('academyEventList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
